import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getReqRates } from 'actions/reqldRates/reqRates';
import { getCountries } from 'actions/countries';

import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';

import * as actionTypes from 'constants/ActionTypes';
import { execute } from 'store/configureStore';
import { call, put } from 'redux-saga/effects';
import api from 'services';
import styles from 'styles';

import ReqLDRatesTable from './ReqLDRatesTable';
import CircularProgress from 'material-ui/CircularProgress';
import { SelectField, MenuItem, AutoComplete, RaisedButton } from 'material-ui';
import _ from 'lodash';

const initialFilter = {
    country: { _id: '', name: '' },
    port: { _id: '', name: '' },
    cargo: { _id: '', name: '' },
    minWeight: null,
    maxWeight: null,
    minVolume: null,
    maxVolume: null,
    ld: 'ld',
};

class RequestLDRates extends React.Component {
    constructor(props) {
        super(props);
        
        const pagination = {
            page: 1,
            limit: 25,
            filter: Object.assign({}, initialFilter),
        };

        this.state = {
            isLoaded: false,
            rowsPerPage: [10, 25, 50, 100],
            rows: [],
            ports: [],
            cargoes: [],
            numberOfRows: 25,
            pagination,
            total: props.total,
            reqLDRates: [],
            openAddDialog: false,
        };
    }

    async UNSAFE_componentWillMount() {
        this.updateRows(this.state).then(() => this.setState({
            isLoaded: true,
        }));
    }

    componentDidMount() {
        this.props.getCountries();
    }

    handleChangePagination = ({ page, numberOfRows }) => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                page,
                limit: numberOfRows,
            },
        }, () => {
            this.updateRows(this.state);
        });
    }

    async updateRows(state) {
        const pagination = {
            ...state.pagination,
        };

        await execute(this.loadRates, pagination);

        this.setState({
            pagination,
        });
    }

    * loadRates(pagination) {
        let response = yield call(api.getReqLDRates, pagination);
        
        if (response && response.status === 400) {
            pagination.page = 1;
            response = yield call(api.getReqLDRates, pagination);
        }

        yield put({
            type: actionTypes.GET_REQ_LD_RATES,
            data: response,
        });
    }

    handleSelectCountry = (e, i) => {
        e.preventDefault();
        if (i === 0) {
            this.updatePaginationFilter('country', { name: '', _id: '' });
            return;
        }

        const { _id, name } = this.props.countries[i - 1];

        this.updatePaginationFilter('country', { name, _id });
    }

    changePortAutoCompete = (searchPort) => {
        this.updatePaginationFilter('port', { name: searchPort, _id: '' }, () => {
            const { name } = this.state.pagination.filter.port;
            
            if (name.length < 2) {
                return;
            }

            api.findPortAdmin({ name })
                .then((response) => {
                    if (response.status === 200) {
                        const ports = response.data.data.map(port => ({
                            name: port.country ? `${port.name}, ${port.country.name}` : port.name,
                            _id: port._id,
                        }));

                        this.setState({
                            ports,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error AutoComplete ports - port of registry', error);

                    return null;
                });
        });
    }

    choosePortAutoComplete = ({ name, _id }) => {
        this.updatePaginationFilter('port', { name, _id });
    }

    changeCargoAutoCompete = (searchCargo) => {
        this.updatePaginationFilter('cargo', { name: searchCargo, _id: '' }, () => {
            const { name } = this.state.pagination.filter.cargo;
            
            if (name.length < 2) {
                return;
            }
            
            api.getCargoNamesAutocomplete(name)
                .then((response) => {
                    if (response.status === 200) {
                        const cargoes = response.data.data.map(cargo => ({
                            name: cargo.name,
                            _id: cargo._id,
                        }));

                        this.setState({
                            cargoes,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error AutoComplete cargoes - cargo of registry', error);

                    return null;
                });
        });
    }

    chooseCargoAutoComplete = ({ name, _id }) => {
        this.updatePaginationFilter('cargo', { name, _id });
    }

    handleChangeWeightVolume = (e, type) => {
        this.updatePaginationFilter(type, parseInt(e.target.value));
    }

    handleFilter = async () => {
        const pagination = {
            ...this.state.pagination,
            page: 1,
        };
        this.setState({
            pagination,
        });
        
        await execute(this.loadRates, pagination);
    }

    handleReset = () => {
        const updateState = {
            pagination: {
                ...this.state.pagination,
                filter: {
                    ...Object.assign({}, initialFilter),
                },
            },
            ports: [],
            cargoes: [],
            isLoaded: false,
        };

        // this.setState(updateState);
        this.updateRows(updateState).then(() => this.setState({
            ...updateState,
            isLoaded: true,
        }));
    }

    updatePaginationFilter = (filter, data, cb) => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                filter: {
                    ...this.state.pagination.filter,
                    [filter]: data,
                },
            },
        }, cb);
    }

    handleOpenAddDialog = () => {
        this.setState({
            openAddDialog: !this.state.openAddDialog,
        });
    }

    handleSelectLD = (val) => {
        this.updatePaginationFilter('ld', val);
    }

    render() {
        const { 
            pagination: {
                page, limit, filter: {
                    country, port, cargo, maxWeight, minWeight, maxVolume, minVolume, ld, 
                }, 
            }, 
            rowsPerPage, 
            ports,
            cargoes,
            openAddDialog,
        } = this.state;
        const { total, countries } = this.props;

        const renderPagination = (<Pagination
            total={total}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={limit}
            updateRows={this.handleChangePagination}
        />);

        return (
            <div className='table-page'>
                <CircularProgress
                    className={!this.state.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />
                <div className={this.state.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            cargo request LD rates
                        </h2>
                        <div className='table-header'>
                            <div className='item' />

                            <div className='item'>
                                {renderPagination}
                            </div>
                        </div>

                        <div className='row'>
                            <div>
                                <SelectField 
                                    style={{ width: '300px', marginLeft: '10px' }}
                                    floatingLabelText='Country'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    maxHeight={400}
                                    value={country._id}
                                    name='countries'
                                    onChange={this.handleSelectCountry}
                                >
                                    <MenuItem 
                                        value=''
                                        primaryText=''
                                    />
                                    {
                                        countries && countries.map(country => (
                                            <MenuItem
                                                key={country._id}
                                                value={country._id}
                                                primaryText={country.name}
                                            />
                                        ))
                                    }
                                </SelectField>
                            </div>
                            <div>
                                <AutoComplete
                                    name='port'
                                    floatingLabelText='Port name'
                                    searchText={port.name}
                                    dataSource={ports}
                                    dataSourceConfig={{ text: 'name', value: 'port' }}
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    onUpdateInput={this.changePortAutoCompete}
                                    onNewRequest={this.choosePortAutoComplete}
                                    filter={AutoComplete.noFilter}
                                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                    style={{ marginLeft: '10px', width: '300px' }}
                                    menuStyle={{ width: '300px' }}
                                    popoverProps={{
                                        canAutoPosition: true,
                                    }}
                                    fullWidth
                                />
                            </div>
                            <div>
                                <AutoComplete 
                                    name='cargo name'
                                    floatingLabelText='Cargo name'
                                    searchText={cargo.name}
                                    dataSource={cargoes}
                                    dataSourceConfig={{ text: 'name', value: 'cargo' }}
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    onUpdateInput={this.changeCargoAutoCompete}
                                    onNewRequest={this.chooseCargoAutoComplete}
                                    filter={AutoComplete.noFilter}
                                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                    style={{ marginLeft: '10px', width: '300px' }}
                                    menuStyle={{ width: '300px' }}
                                    popoverProps={{
                                        canAutoPosition: true,
                                    }}
                                    fullWidth
                                />
                            </div>

                            <div>
                                <RaisedButton
                                    style={{ margin: '27px 0 0 10px' }} 
                                    primary
                                    label='Search'
                                    onClick={this.handleFilter}
                                />
                            </div>
                            <div>
                                <RaisedButton 
                                    style={{ margin: '27px 0 0 10px' }}
                                    secondary
                                    label='Reset'
                                    onClick={this.handleReset}
                                />
                            </div>
                            <div>
                                <RaisedButton 
                                    style={{ margin: '27px 0 0 10px' }}
                                    backgroundColor='#a4c639'
                                    labelColor='#fff'
                                    label='ADD'
                                    onClick={this.handleOpenAddDialog}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div>
                                <TextField
                                    style={{ width: '90px', marginLeft: '10px' }}
                                    floatingLabelText='Min weight'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    type='number'
                                    value={minWeight || ''}
                                    onChange={e => this.handleChangeWeightVolume(e, 'minWeight')}
                                />
                            </div>
                            <div>
                                <TextField
                                    style={{ width: '90px', marginLeft: '10px' }}
                                    floatingLabelText='Max weight'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    type='number'
                                    value={maxWeight || ''}
                                    onChange={e => this.handleChangeWeightVolume(e, 'maxWeight')}
                                />
                            </div>
                            <div>
                                <TextField
                                    style={{ width: '90px', marginLeft: '10px' }}
                                    floatingLabelText='Min volume'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    type='number'
                                    value={minVolume || ''}
                                    onChange={e => this.handleChangeWeightVolume(e, 'minVolume')}
                                />
                            </div>
                            <div className="text-right">
                                <TextField
                                    style={{ width: '90px', marginLeft: '10px' }}
                                    floatingLabelText='Max volume'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    type='number'
                                    value={maxVolume || ''}
                                    onChange={e => this.handleChangeWeightVolume(e, 'maxVolume')}
                                />
                            </div>
                            <div>
                                <SelectField 
                                    style={{ width: '90px', marginLeft: '10px' }}
                                    floatingLabelText='Type'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    maxHeight={400}
                                    value={ld}
                                    name='ld'
                                    onChange={(e, i, v) => this.handleSelectLD(v)}
                                >
                                    <MenuItem 
                                        key='L/D'
                                        value='ld'
                                        primaryText='L/D'
                                    />
                                    <MenuItem 
                                        key='L'
                                        value='loading'
                                        primaryText='L'
                                    />
                                    <MenuItem 
                                        key='D'
                                        value='discharging'
                                        primaryText='D'
                                    />
                                </SelectField>
                            </div>
                        </div>
                        <div className='table-body'>
                            <ReqLDRatesTable 
                                rates={this.props.reqLDRates}
                                pagination={this.state.pagination}
                                loadRates={this.loadRates}
                                countries={countries}
                                openAddDialog={openAddDialog}
                                handleOpenAddDialog={this.handleOpenAddDialog}
                            />
                        </div>
                        <div className='item'>
                            {renderPagination}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        reqLDRates: state.reqLDRates.reRatesList,
        total: state.reqLDRates.reqRatesTotalCount,
        countries: state.countries.items,
    }),
    dispatch => bindActionCreators(
        {
            getReqRates,
            getCountries,
        },
        dispatch,
    ),
)(RequestLDRates);



// WEBPACK FOOTER //
// ./app/components/Cargoes/RequestsLDRates/ReqLDRates.jsx